<template>
  <div class="profile">
    <SvgMobileTransportLogo class="profile__logo" />

    <ListButton>
      <DropdownMenuButton
        data-testid="dropdown-menu-button"
        :isProfile="true"
        class="tw-pointer-events-none tw-px-2 tw-py-4"
      />
      <NuxtLink
        to="/carrier-profile"
        class="profile__link profile--border-top tw-pt-5"
        v-if="isFeatureEnabled"
        @click="
          useMixpanelTrack('lb2 mobile carrier-profile link clicked', {
            from: route.fullPath,
          })
        "
      >
        <div class="tw-flex">
          <div class="tw-w-[50px]">&nbsp;</div>
          <ui-badge state="success">
            <span class="tw-mr-2">Profile Settings</span>
            <template #badge><span class="tw-px-2">New</span></template>
          </ui-badge>
        </div>
        <ui-icon
          :size="24"
          type="outlined"
          class="tw-text-grey-dark"
        >
          chevron_right
        </ui-icon>
      </NuxtLink>
    </ListButton>

    <ListButton>
      <NuxtLink
        to="https://forms.gle/AobtohvG2NWyYVPa9"
        class="profile__link"
        target="_blank"
        data-testid="feedback-link"
        @click="useMixpanelTrack('lb2 profile send feedback button clicked')"
      >
        <div class="tw-flex">
          <ui-icon
            :size="24"
            type="outlined"
            class="tw-mr-4 tw-text-grey-dark"
          >
            feedback
          </ui-icon>
          <span>Send Feedback</span>
        </div>
        <ui-icon
          :size="24"
          type="outlined"
          class="tw-text-grey-dark"
        >
          chevron_right
        </ui-icon>
      </NuxtLink>
    </ListButton>

    <ListButton>
      <NuxtLink
        to="https://transport.acvauctions.com/legal"
        target="_blank"
        class="profile__link"
        data-testid="legal-link"
        @click="useMixpanelTrack('lb2 legal button clicked')"
      >
        <div class="tw-flex">
          <ui-icon
            :size="24"
            type="outlined"
            class="tw-mr-4 tw-text-grey-dark"
          >
            gavel
          </ui-icon>

          <span>Legal</span>
        </div>
        <ui-icon
          :size="24"
          type="outlined"
          class="tw-text-grey-dark"
        >
          chevron_right
        </ui-icon>
      </NuxtLink>
    </ListButton>

    <ListButton
      @click="useMixpanelTrack('lb2 customer support button clicked')"
      v-for="(item, index) in computedCustomerSupportInformation"
      :key="index"
    >
      <div>
        <div class="profile__large-item profile--border-bottom">
          <ui-icon
            :size="24"
            type="outlined"
            class="tw-mr-4 tw-text-grey-dark"
          >
            support_agent
          </ui-icon>
          <div class="tw-pb-5">
            <span class="tw-mb-2">{{ item.name }}</span>
          </div>
          <div
            class="tw-pb-5"
            v-if="item.amName"
          >
            <span class="tw-mb-2">{{ item.amName }}</span>
          </div>
        </div>
        <div class="profile--border-bottom tw-px-14">
          <a
            class="profile__anchor tw-py-5"
            :href="`tel:${item.rawPhoneNumber}`"
            target="_blank"
          >
            {{ item.phoneNumber }}
          </a>
        </div>
        <div
          class="tw-px-14"
          v-if="item.amEmail"
        >
          <a
            class="profile__anchor tw-pt-5"
            :href="`mailto:${item.amEmail}`"
            target="_blank"
          >
            {{ item.amEmail }}
          </a>
        </div>
        <div class="tw-px-14">
          <a
            class="profile__anchor tw-pb-5 tw-pt-5"
            :href="`mailto:${item.email}`"
            target="_blank"
          >
            {{ item.email }}
          </a>
        </div>
        <div class="profile--border-top tw-px-14">
          <div class="tw-pt-5">
            {{ item.businessHours }}
          </div>
        </div>
      </div>
    </ListButton>

    <ListButton
      @click="handleLogout()"
      data-testid="logout-button"
    >
      <button class="profile__link tw-w-full tw-border-none tw-bg-transparent">
        <span class="tw-flex">
          <ui-icon
            :size="24"
            type="outlined"
            class="tw-mr-4 tw-text-grey-dark"
          >
            file_download
          </ui-icon>
          <span class="profile__roboto tw-font-medium">Logout</span>
        </span>

        <ui-icon
          :size="24"
          type="outlined"
          class="tw-text-grey-dark"
        >
          chevron_right
        </ui-icon>
      </button>
    </ListButton>
  </div>
</template>

<script setup>
const isFeatureEnabled = ref(false);
const route = useRoute();
const { logout } = useLogout();

onMounted(async () => {
  const { isCarrierProfileEnabled } = await useIsCarrierProfileEnabled();
  isFeatureEnabled.value = isCarrierProfileEnabled.value;
});

const handleLogout = () => {
  useMixpanelTrack('lb2 logout button clicked');

  logout();
};

const computedCustomerSupportInformation = computed(() => useCustomerSupportInformation());
</script>

<style lang="scss" scoped>
.profile {
  @apply tw-mb-15 tw-px-4 tw-py-7;

  .profile__logo {
    @apply tw-mb-7;
  }

  .profile--border-bottom {
    border-bottom: 1px solid;
    @apply tw-border-border-base;
  }

  .profile--border-top {
    border-top: 1px solid;
    @apply tw-border-border-base;
  }

  .profile__link {
    @apply tw-flex tw-items-center tw-justify-between tw-px-4 tw-text-base tw-font-medium tw-text-text-secondary tw-no-underline;
  }

  .profile__large-item {
    @apply tw-flex tw-px-4 tw-text-base tw-no-underline;
  }

  .profile__anchor {
    @apply tw-block tw-font-medium tw-text-text-link-on-light tw-no-underline;
  }

  .profile__roboto {
    font-family: 'Roboto';
  }
}
</style>
